module.exports = __webpack_public_path__ + "static/img/mt_download_use_case_3.dc09b88.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_download_use_case_3.png
// module id = 351
// module chunks = 2